import React, { type ReactNode } from 'react';

import { cn } from '@change/ds-utils';

import { useParallaxWrapper } from './hooks/useParallaxWrapper/useParallaxWrapper';

export type ParallaxWrapperProps = {
	children: ReactNode;
	strength?: number;
	maxShift?: number;
	mobileStrength?: number;
	mobileMaxShift?: number;
	className?: string;
};

export const ParallaxWrapper: React.FC<ParallaxWrapperProps> = ({
	children,
	strength = 2.5,
	maxShift = 400,
	mobileStrength = 2.4,
	mobileMaxShift = 390,
	className = '',
}) => {
	const { wrapperRef } = useParallaxWrapper({
		strength,
		maxShift,
		mobileStrength,
		mobileMaxShift,
	});

	return (
		<div
			ref={wrapperRef}
			className={cn(
				'will-change-transform',
				'[&:not([data-scrolling])]:duration-t5 [&:not([data-scrolling])]:transition-transform [&:not([data-scrolling])]:ease-out',
				'motion-reduce:transform-none motion-reduce:transition-none motion-reduce:will-change-auto',
				className,
			)}
			aria-hidden="true"
		>
			{children}
		</div>
	);
};
